<template>
  <div v-if="isCandidate">
    <h1 class="page-title">{{ $t('NotDisturbMode.title') }}</h1>
    <p>{{ $t('NotDisturbMode.first_describe') }}</p>
    <p>{{ $t('NotDisturbMode.second_describe') }}</p>
    <form @submit.prevent="submit">
      <date-picker v-model="disturbDate" :datepickerOptions="datepickerOptions" class="input-group date col-md-5 p-l-0"/>
      <div class="m-t-20">
        <router-link :to="{ name: 'Dashboard' }" class="btn btn-default btn-cons">{{ $t('buttons.cancel') }}</router-link>
        <button type="submit" class="btn btn-primary btn-cons">{{ $t('buttons.validate') }}</button>
      </div>
    </form>
  </div>
</template>

<script type="text/javascript">
  import { mapGetters, mapActions } from 'vuex'
  import { checkRoleCandidate } from '@/helpers/roles'
  import DatePicker from '@/components/pages/DatePicker'
  import { NOT_DISTURB_STATUS } from '@/store/modules/auth'
  import { sendCandidateActiveNotDisturbEvent } from '@/helpers/at_internet/follow_candidate'

  export default {
    name: 'NotDisturbMode',
    components: {
      DatePicker
    },
    data: function() {
      return ({ disturbDate: '' })
    },
    computed: {
      ...mapGetters({
        currentUser: 'auth/currentUser'
      }),
      notDisturbDate() {
        return this.$options.filters.formatDate(this.currentUser.not_disturb_until)
      },
      datepickerOptions() {
        return {
          endDate: new Date(moment().add(30, 'days').calendar())
        }
      },
      isCandidate() {
        return checkRoleCandidate(this.currentUser.role)
      }
    },
    methods: {
      ...mapActions({
        setNotDisturbStatus: 'auth/setNotDisturbStatus',
        activeNotDisturb: 'users/activeNotDisturb'
      }),
      redirectToDashboard() {
        this.$router.push({ name: 'Dashboard' })
      },
      submit() {
        this.activeNotDisturb(this.disturbDate)
        .then(response => {
          if(response.status == 201) this.redirectToDashboard()
        })
        // At Internet for candidtate active not disturb
        if (this.disturbDate) {
          sendCandidateActiveNotDisturbEvent();
        }
      }
    },
    mounted: function() {
      this.disturbDate = this.notDisturbDate
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/NotDisturbMode.vue